'use client';

import { c as _c } from "react/compiler-runtime";
import Swimlane from '@/app/[locale]/(worlds)/components/Swimlane';
import EditorChoiceDescription from '@/components/EditorChoiceDescription';
import { cn } from '@/lib/utils';
import type { WorldCardLane } from '@/types/viverse-world-card';
type WorldSectionProps = {
  index: number;
  world: WorldCardLane;
};
function WorldSection(t0) {
  const $ = _c(17);
  const {
    index,
    world
  } = t0;
  const title = world.title ?? "";
  let t1;
  if ($[0] !== title) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = /\s+/g;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    t1 = title.toLowerCase().trim().replace(t2, "-");
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const slug = t1;
  const hasNonAscii = [...title].some(_temp);
  const rowKey = slug && !hasNonAscii ? slug : world.id;
  const t2 = String(index + 1);
  let t3;
  if ($[3] !== rowKey || $[4] !== t2 || $[5] !== title || $[6] !== world.id) {
    t3 = {
      "data-ph-capture-attribute-row-index": t2,
      "data-ph-capture-attribute-row-name": title,
      "data-ph-capture-attribute-row-key": rowKey,
      "data-ph-capture-attribute-row-id": world.id
    };
    $[3] = rowKey;
    $[4] = t2;
    $[5] = title;
    $[6] = world.id;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = world.title;
  let t5;
  if ($[8] !== world.description) {
    t5 = <EditorChoiceDescription description={world.description} />;
    $[8] = world.description;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = world.is_ranked;
  const t7 = world.is_ranked ? "-mt-4 -mb-12 pt-4 pb-12" : "-mt-2 -mb-12 pt-2 pb-12";
  let t8;
  if ($[10] !== t7) {
    t8 = cn("no-scrollbar flex w-full flex-1 gap-4 overflow-x-auto pl-4 select-none lg:pl-6", t7);
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t3 || $[13] !== t5 || $[14] !== t8 || $[15] !== world) {
    t9 = <Swimlane data-component="world-section" captureAttributes={t3} className="gap-3" title={t4} description={t5} world={world} cardVariant="viverse" ranking={t6} hideLiked={true} hidePremiumBadge={false} dataRoomIdPrefix="ws" lastCardClassName="mr-4 md:mr-9 lg:mr-6" scrollClassName={t8} />;
    $[12] = t3;
    $[13] = t5;
    $[14] = t8;
    $[15] = world;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
}
function _temp(ch) {
  return ch.charCodeAt(0) > 127;
}
export default WorldSection;